import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import axios from "axios";
import config from "../../../../config/config";
import { toastError, toastSuccess } from "../../../../common/Toast";
import { ERROR_MESSAGE, SUCCESS_MESSAGE } from "../../../../common/Constant";

const ImportItems = () => {
  let fields, excelReadData;

  let defaultStatus = 3;
  const paramObject = useParams();
  const Id = localStorage.getItem("ID");
  const token = localStorage.getItem("Token");
  const [loading, setLoading] = useState(false);
  const locationId = localStorage.getItem("Location");

  // Step 1 - Download Excel-
  const downloadExcel = () => {
    const inventoryExcelColumnName = [
      { Field: "Item Number" },
      { Field: "Product ID" },
      { Field: "Item Name" },
      { Field: "Barcode Display Name" },
      { Field: "Category" },
      { Field: "Supplier Id" },
      { Field: "Inactive" },
      { Field: "Cost Price" },
      { Field: "Selling Price" },
      { Field: "Promo Price" },
      { Field: "Promo Start Date" },
      { Field: "Promo End Date" },
      { Field: "Price Includes Tax" },
      { Field: "Reorder Level" },
      { Field: "Replenish Level" },
      { Field: "Description" },
      { Field: "Long Description" },
      { Field: "Information Popup when adding to sale" },
      { Field: "Weight" },
      { Field: "Weight Unit" },
      { Field: "Length" },
      { Field: "Width" },
      { Field: "Height" },
      { Field: "Commission" },
      { Field: "Tax Group" },
      { Field: "Tags" },
      { Field: "Days to expiration" },
      { Field: "Manufacturer" },
      { Field: "Brand" },
    ];
    console.log("inventoryExcelColumnName ==> ", inventoryExcelColumnName);

    let dataFields = inventoryExcelColumnName.map((obj) => obj.Field);
    console.log("dataFields ==> ", dataFields);

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet([]);
    // XLSX.utils.sheet_add_aoa(ws, data);
    XLSX.utils.sheet_add_aoa(ws, [dataFields]);
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    const binaryData = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([binaryData], { type: "application/octet-stream" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = "items_import_sonarpos_template.xlsx";
    link.click();
  };

  // Step 2 - Handle File-
  const handleFile = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onload = (e) => {
      const binaryData = e.target.result;
      const workbook = XLSX.read(binaryData, { type: "binary" });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const rawData = XLSX.utils.sheet_to_csv(sheet);

      const processedData = Papa.parse(rawData, {
        header: true,
        transformHeader: (header) => header.replace(/\s+|-|\/|#/g, ""),
      }).data;
      excelReadData = processedData;

      const rows = rawData.split("\n");
      const data = rows.map((row) => row.split(","));
      fields = data[0];
    };

    reader.readAsBinaryString(file);
  };

  //   Step 3 - Handle Submit-
  const handleSubmit = () => {
    // setLoading(true);
    const changeCountInventoryArray = excelReadData?.map((obj, index) => ({
      Id: index + 1,
      BarcodeDisplayName: obj.BarcodeDisplayName,
      Brand: obj.Brand,
      Category: obj.Category,
      Commission: obj.Commission,
      CostPrice: obj.CostPrice,
      Daystoexpiration: obj.Daystoexpiration,
      Description: obj.Description,
      Height: obj.Height,
      Inactive: obj.Inactive,
      InformationPopupwhenaddingtosale: obj.InformationPopupwhenaddingtosale,
      ItemName: obj.ItemName,
      ItemNumber: obj.ItemNumber,
      Length: obj.Length,
      LongDescription: obj.LongDescription,
      Manufacturer: obj.Manufacturer,
      PriceIncludesTax: obj.PriceIncludesTax,
      ProductID: obj.ProductID,
      PromoEndDate: obj.PromoEndDate,
      PromoPrice: obj.PromoPrice,
      PromoStartDate: obj.PromoStartDate,
      ReorderLevel: obj.ReorderLevel,
      ReplenishLevel: obj.ReplenishLevel,
      SellingPrice: obj.SellingPrice,
      SupplierId: obj.SupplierId,
      Tags: obj.Tags,
      TaxGroup: obj.TaxGroup,
      Weight: obj.Weight,
      WeightUnit: obj.WeightUnit,
      Width: obj.Width,
    }));

    let CountInventoryExcel = changeCountInventoryArray?.filter(function (
      countinventoryexcel
    ) {
      return countinventoryexcel.ItemIdItemNumberProductID !== "";
    });

    const countinventoryexcelobj = {};
    countinventoryexcelobj.importDataXML = CountInventoryExcel;
    let countinventoryexceljsonstring = JSON.stringify(countinventoryexcelobj);

    return;
    axios
      .post(
        `${config.itemsBaseUrl}/items/countitemsinventory`,
        {
          xmlImportData: countinventoryexceljsonstring,
          loginUserId: Id,
          inventoryCountId: paramObject.id,
          locationId: locationId,
          status: defaultStatus,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID == 1) {
          // setSuccessMessageHideShow(true);
          toastSuccess(SUCCESS_MESSAGE);
        } else {
          // setSuccessMessageHideShow(false);
          toastError(ERROR_MESSAGE);
        }
        // setLoading(false);
      })
      .catch((err) => {
        console.log("err ==> ", err);
        // setLoading(false);
      });
  };

  return (
    <>
      {/* <Loader loading={loading} /> */}
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div className="page-header"
           style={
            {
              position: "fixed",
              top: "2px",
              zIndex: "999"
            }
          }
          >
            <div className="row" style={{ marginTop: "5px" }}>
              <h3 className="page-title">Import Items</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/items">Items</Link>
                </li>
                <li className="breadcrumb-item active">Excel Import</li>
              </ul>
            </div>
          </div>
          <div className="card">
            <div className="card-header">
              <h6 className="fw-bold">Mass Import Data From Excel Sheet</h6>
            </div>
            <div className="card-body">
              <div className="d-flex flex-row">
                {/* Step 1 */}
                <div className="p-2">
                  <div className="d-flex flex-row">
                    <div className="p-2">
                      <h4 className="fw-bold mb-2">Step 1:</h4>
                    </div>
                    <div className="p-2 mb-2">
                      <h5> Download file for items</h5>
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={downloadExcel}
                      >
                        Download Excel Template for Items
                      </button>
                    </div>
                  </div>
                </div>
                {/* Step 2 */}
                <div className="p-2">
                  <div className="d-flex flex-row">
                    <div className="p-2">
                      <h4 className="fw-bold mb-2">Step 2:</h4>
                    </div>
                    <div className="p-2 mb-2">
                      <h5>Import file</h5>
                      {/* <div className="row"> */}
                      <input
                        type="file"
                        className="form-control form-control-sm"
                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        onChange={handleFile}
                      />
                      {/* </div> */}
                    </div>
                  </div>
                </div>
                {/* Step 3 */}
                <div className="p-2">
                  <div className="d-flex flex-row">
                    <div className="p-2">
                      <h4 className="fw-bold mb-2">Step 3:</h4>
                    </div>
                    <div className="p-2 mb-2">
                      <h5>Final Submit</h5>
                      {/* <div className="row"> */}
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={handleSubmit}
                      >
                        Submit
                      </button>
                      {/* </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ImportItems;
